module.exports = __webpack_public_path__ + "img/MCS.af1f294e.png";